import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from './FeaturedItem.module.css';

const FeaturedItem = ({ img, title, explanation, direction = 'left', imgAlt = '', imgClassName = '', className = '' }) => {
  const isRight = direction === 'right';

  return (
    <Row className={`${styles.featuredRow} ${className}`}>
      <Col md={6} className={isRight ? 'order-md-2' : 'order-md-1'}>
        <div className={styles.imageWrapper}>
          <img src={img} alt={imgAlt || title} className={`${styles.image} ${imgClassName}`} />
        </div>
      </Col>

      <Col md={6} className={isRight ? 'order-md-1 d-flex align-items-center' : 'order-md-2 d-flex align-items-center'}>
        <div className={styles.textWrap}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.explanation}>{explanation}</p>
        </div>
      </Col>
    </Row>
  );
};

export default FeaturedItem;
